import React, { useEffect, useRef, useState } from "react";
import { Infinity as InfinityIcon } from "lucide-react";
import { NEXT_DROP } from "../mock/mock";

const MESSAGES = [
  "ALWAYS-N-ANYTIME — DROP IS LIVE",
  "MADE-TO-ORDER · SHIPS WORLDWIDE",
  "__COUNTDOWN__",
  "FOREVER · LOYALTY · NO LIMITS",
];

function fmt(target) {
  const ms = Math.max(0, new Date(target).getTime() - Date.now());
  const d = Math.floor(ms / 86400000);
  const h = Math.floor((ms / 3600000) % 24);
  const m = Math.floor((ms / 60000) % 60);
  const s = Math.floor((ms / 1000) % 60);
  const p = (n) => String(n).padStart(2, "0");
  return `${d}d ${p(h)}h ${p(m)}m ${p(s)}s`;
}

export default function AnnouncementBar() {
  const [idx, setIdx] = useState(0);
  const [show, setShow] = useState(true);
  const [cd, setCd] = useState(() => fmt(NEXT_DROP));
  const timer = useRef();

  useEffect(() => {
    const id = setInterval(() => setCd(fmt(NEXT_DROP)), 1000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    timer.current = setInterval(() => {
      setShow(false);
      setTimeout(() => {
        setIdx((i) => (i + 1) % MESSAGES.length);
        setShow(true);
      }, 260);
    }, 4200);
    return () => clearInterval(timer.current);
  }, []);

  const item = MESSAGES[idx];
  const content =
    item === "__COUNTDOWN__" ? (
      <span className="inline-flex items-center gap-2">
        <span className="text-white/60">Next drop closes in</span>
        <span className="text-neon font-bold tabular-nums">{cd}</span>
      </span>
    ) : (
      <span className="inline-flex items-center gap-2">
        <InfinityIcon size={12} className="text-neon shrink-0" />
        <span>{item}</span>
      </span>
    );

  return (
    <div
      data-testid="announcement-bar"
      className="fixed top-0 inset-x-0 z-[60] h-9 bg-black border-b border-neon/25 flex items-center justify-center overflow-hidden select-none"
    >
      <div
        key={idx}
        className={`text-[10px] md:text-[11px] font-bold uppercase tracking-[0.22em] text-white/85 transition-opacity duration-300 px-4 text-center ${
          show ? "opacity-100" : "opacity-0"
        }`}
        data-testid="announcement-message"
      >
        {content}
      </div>
    </div>
  );
}
